import React from "react";
import { getSelectableFonts } from "~/cores/appCore";
import TurnrSupportEmail from "~/components/links/TurnrSupportEmail.jsx";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import TurnrInput from "~/components/input/TurnrInput.jsx";

export function getAddFontTooltipInfo() {
    return (
        <div>
            If you want a font that does not show in the dropdown. Please contact us at <TurnrSupportEmail />. <br />
            <br />
            If it's your custom font make sure to include the actual font-files in the email. In OTF and/or TTF format.
        </div>
    );
}

export default function FontSettings(props) {
    const { iFrameData, appProps } = props;
    const selectableFonts = getSelectableFonts(appProps, {
        fonts: iFrameData?.fonts,
    });

    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip={getAddFontTooltipInfo()}
                    label="Font"
                    fullWidth={true}
                    {...props.fontNamePrimary}
                    onChange={props.setFontNamePrimary}
                    options={selectableFonts.map((font) => font?.id || font)}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The color of regular text"
                    label={"Text color: " + props.textColor.value}
                    type="color"
                    fullWidth={true}
                    {...props.textColor}
                    onChange={props.setTextColor}
                    required
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="The color of regular text"
                    label={"Secondary text color: " + props.textColorSecondary.value}
                    type="color"
                    fullWidth={true}
                    {...props.textColorSecondary}
                    onChange={props.setTextColorSecondary}
                    required
                />
            </InputGridWrapper>
            {/*<InputGridWrapper>*/}
            {/*    <TurnrDropdownSelect*/}
            {/*        size={"small"}*/}
            {/*        tooltip="Change the body font size"*/}
            {/*        label="Font size"*/}
            {/*        fullWidth={true}*/}
            {/*        {...props.fontSizeBody}*/}
            {/*        onChange={props.setFontSizeBody}*/}
            {/*        options={["11px", "12px", "14px", "16px", "18px"]}*/}
            {/*    />*/}
            {/*</InputGridWrapper>*/}
            {/*<InputGridWrapper>*/}
            {/*    <TurnrDropdownSelect*/}
            {/*        size={"small"}*/}
            {/*        label="Font weight"*/}
            {/*        tooltip="Change the thickness of your selected font"*/}
            {/*        fullWidth={true}*/}
            {/*        {...props.fontWeightBody}*/}
            {/*        onChange={props.setFontWeightBody}*/}
            {/*        options={["Normal", "Bold", "Thin"]}*/}
            {/*    />*/}
            {/*</InputGridWrapper>*/}
        </SettingsContainerWrapper>
    );
}
